import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';

import {DEFAULT_INDIVIDUAL_FILTERS, TFilters, TFiltersConfig} from './definitions';

const countTopLevelDifferences = (firstObject: TAnyObject, secondObject: TAnyObject) => {
  const allKeys = new Set([...Object.keys(firstObject), ...Object.keys(secondObject)]);

  return Array.from(allKeys).reduce((acc, key) => {
    if (!isEqual(firstObject[key], secondObject[key])) {
      return acc + 1;
    }

    return acc;
  }, 0);
};

const prepareFiltersToCompare = (
  filters: TAnyObject,
  individualFilters: string[] = DEFAULT_INDIVIDUAL_FILTERS,
) => {
  return omit(filters, individualFilters);
};

export const getDifferenceCount = <T>(filters: TFilters<T>, filtersConfig?: TFiltersConfig<T>) => {
  if (!filters?.data || !filtersConfig?.defaultFilters) {
    return 0;
  }

  const filtersToCompare = prepareFiltersToCompare(filters?.data, filtersConfig?.individualFilters);

  const defaultFiltersToCompare = prepareFiltersToCompare(
    filtersConfig?.defaultFilters,
    filtersConfig?.individualFilters,
  );

  return countTopLevelDifferences(filtersToCompare, defaultFiltersToCompare);
};
